module.exports = __webpack_public_path__ + "static/media/gig_large.b62b0688.png";